<div class="permit-tab"> 
    <p class="sub-form-title no-margin">Search Result</p>

            <form [formGroup]="dateForm" class="row row-padding" (submit)="onSubmitDates()">
             <div class="col-4">
              <mat-form-field  class="mat-date-pick">
                <mat-label>Month</mat-label>
                <mat-select formControlName="month">
                  <!-- <mat-option>--</mat-option> -->
                  <mat-option  [value]="month.val" *ngFor="let month of months">{{month.name}}</mat-option>
                </mat-select>
                <!-- {{selectYearError}} -->

              </mat-form-field>
              <mat-error class="mat-err-style" *ngIf="selectYearError">
                Please select year 
              </mat-error>  
             </div>
             <div class="col-4">
              <mat-form-field  class="mat-date-pick">
                <mat-label>Year</mat-label>
                <mat-select formControlName="year">
                  <!-- <mat-option>--</mat-option> -->
                  <mat-option  [value]="year.year" *ngFor="let year of years">{{year.year}}</mat-option>
                </mat-select>
                <!-- {{selectYearError}}
                <mat-error *ngIf="selectYearError">
                  Please enter year
                </mat-error>   -->
              </mat-form-field>
              <mat-error class="mat-err-style" *ngIf="selectMonthError">
                Please select month 
              </mat-error>  
             </div>
             <!-- <div class="col-3"> 
                 <mat-form-field  class="mat-date-pick">
                     <mat-label>End date</mat-label>
                     <input matInput [matDatepicker]="picker1" formControlName="endDate" 
                     [min]="dateForm.controls['startDate'].value? dateForm.controls['startDate'].value : maxDate" required />
                     <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                     <mat-datepicker #picker1></mat-datepicker>
                     <mat-error *ngIf="dateForm.get('endDate').hasError('required')">
                      Please enter End date
                    </mat-error> 
                   </mat-form-field>                     
             </div> -->
             <div class="col-4">
                <mat-form-field  class="mat-date-pick">
                    <mat-label>Plate No.</mat-label>
                    <input matInput formControlName="plateNo"/>
                    <!-- <mat-error *ngIf="dateForm.get('plateNo').hasError('required')">
                       Please enter
                       <strong>plate Number</strong> 
                     </mat-error>-->
                 </mat-form-field>
             </div>
             <div class="col-4 display-flex">
                 <button mat-button class="button-primary no-top-margins" [disabled]="disableBtn" color="vov-ui-primary">Search Permit</button>
                 <span ><button style="padding: 22px;" type="reset" class="semi-button semi-reset"  color="vov-ui-primary" (click)="reset()">Reset</button></span> 
             </div>
            </form> 
           <p  class="sub-form-title no-margin">Permit Table</p>
           <app-spinner *ngIf="showSpinner; else content"></app-spinner>   
           <ng-template #content>
           <div class = "box" *ngIf="permits.length;"> 
            <div class="export-button">
              <button mat-button  [disabled]="!permits.length" (click)="exportAsXLSX()" color="vov-ui-primary"><i class="fa fa-upload" aria-hidden="true"></i>Export CSV</button>
              </div>
             <app-table [tableData]="permits"  [tableColumnsNames]="columnNames"></app-table> 
           </div>
           <p *ngIf="permits.length == 0">No Data Found</p>       
            </ng-template> 
</div> 

<ng-template #confirmRef1>
  <div class="dialog-Container" style="margin-top:-20px;"> 
    <mat-dialog-actions  class="d-inline-block float-right">
      <h4 class="d-inline-block" style="color:#6A0721">Confirmation</h4>
       <!-- <button mat-dialog-close class="dialog-btn-trans text-white">X</button> -->
     </mat-dialog-actions>    
  <mat-dialog-content class="delete-Conatiner">
     <p class="dialog-cls">Please select month </p>
     <div style="text-align:center;padding-top:10px;"><button mat-button style="background-color: #6A0721;cursor: pointer;" (click)="onClose1()" class="confirm-btn">Ok</button></div>
    </mat-dialog-content>
  </div>
</ng-template> 

<ng-template #confirmRef2>
  <div class="dialog-Container" style="margin-top:-20px;"> 
    <mat-dialog-actions  class="d-inline-block float-right">
      <h4 class="d-inline-block" style="color:#6A0721">Confirmation</h4>
       <!-- <button mat-dialog-close class="dialog-btn-trans text-white">X</button> -->
     </mat-dialog-actions>    
  <mat-dialog-content class="delete-Conatiner">
     <p class="dialog-cls">Please select year </p>
     <div style="text-align:center;padding-top:10px;"><button mat-button style="background-color: #6A0721;cursor: pointer;" (click)="onClose2()" class="confirm-btn">Ok</button></div>
    </mat-dialog-content>
  </div>
</ng-template> 
